export const SAVED_SEARCH_FROM_DASHBOARD = "saved_search_from_dashboard"
